<template>
    <div>
        <v-form ref="form" v-if="!formSend" lazy-validation>
            <h2>{{ 'complaint form header' | translation }}</h2>
            <p>
                {{ 'complaint form hint 1' | translation }}
            </p>
            <v-text-field
                v-model="firstName"
                v-bind:label="'name' | translation"
                data-vv-name="firstName"
                required
                :rules="rules.required"
            ></v-text-field>
            <v-text-field
                v-model="lastName"
                v-bind:label="'surname' | translation"
                data-vv-name="surname"
                :rules="rules.required"
                required
            ></v-text-field>
            <v-text-field
                v-model="orderId"
                v-bind:label="'order id' | translation"
                data-vv-name="orderId"
            ></v-text-field>
            <v-select
                :items="brands"
                v-bind:label="'brand' | translation"
                :rules="rules.required"
                required
                v-model="brand"
            ></v-select>
            <v-text-field
                v-model="productName"
                v-bind:label="'product name' | translation"
                data-vv-name="productName"
                :rules="rules.required"
                required
            ></v-text-field>
            <v-text-field
                v-model="serialNumber"
                v-bind:label="'serial number' | translation"
                data-vv-name="serialNumber"
                :rules="rules.required"
                required
            ></v-text-field>
            <div class="v-messages theme--light">
                <div class="v-messages__message">
                    {{ 'complaint_hint_serial_number' | translation }}
                </div>
            </div>
            <v-text-field
                v-model="phone"
                v-bind:label="'phone' | translation"
                data-vv-name="phone"
                :rules="rules.phone"
                required
            ></v-text-field>
            <v-text-field
                v-model="email"
                v-bind:label="'email' | translation"
                data-vv-name="email"
                :rules="rules.email"
                required
            ></v-text-field>
            <v-textarea
                v-model="message"
                v-bind:label="'message/concern' | translation"
                data-vv-name="message"
                :rules="rules.required"
                required
            ></v-textarea>
            <file-input
                name="invoice"
                v-bind:label="'invoice' | translation"
                v-model="invoice"
                :fileSizeLimit="10240"
                accept=".jpg, .jpeg, .gif, .png, .pdf, .mp4"
                :rules="rules.extension"
            ></file-input>
            <div class="v-messages theme--light">
                <div class="v-messages__message">
                    {{ 'complaint_hint_invoice' | translation }}
                </div>
            </div>
            <file-input
                v-model="images.photo1"
                v-bind:label="'damage picture 1' | translation"
                :fileSizeLimit="10240"
                accept=".jpg, .jpeg, .gif, .png, .pdf, .mp4"
                :rules="rules.required.concat(rules.extension)"
                required
            ></file-input>
            <div class="v-messages theme--light">
                <div class="v-messages__message">
                    {{ 'complaint_hint_photos' | translation }}
                </div>
            </div>
            <file-input
                v-model="images.photo2"
                v-bind:label="'damage picture 2' | translation"
                :fileSizeLimit="10240"
                accept=".jpg, .jpeg, .gif, .png, .pdf, .mp4"
                :rules="rules.extension"
            ></file-input>
            <file-input
                v-model="images.photo3"
                v-bind:label="'damage picture 3' | translation"
                :fileSizeLimit="10240"
                accept=".jpg, .jpeg, .gif, .png, .pdf, .mp4"
                :rules="rules.extension"
            ></file-input>
            <file-input
                v-model="images.photo4"
                v-bind:label="'damage picture 4' | translation"
                :fileSizeLimit="10240"
                accept=".jpg, .jpeg, .gif, .png, .pdf, .mp4"
                :rules="rules.extension"
            ></file-input>
            <file-input
                v-model="images.packing"
                v-bind:label="'packing picture' | translation"
                :fileSizeLimit="10240"
                accept=".jpg, .jpeg, .gif, .png, .pdf, .mp4"
                :rules="rules.required.concat(rules.extension)"
                required
            ></file-input>
            <div class="v-messages theme--light">
                <div class="v-messages__message">
                    {{ 'complaint_hint_photos_packing' | translation }}
                </div>
            </div>
            <br />
            <h4>{{ 'complaint form hint mandatory fields' | translation }}</h4>
            <br />
            <p>
                {{ 'complaint form text 1' | translation }}
            </p>
            <p>
                {{ 'complaint form text 2' | translation }}
            </p>
            <v-checkbox
                required
                :rules="rules.required"
                v-bind:label="'complaint form checkbox 2' | translation"
            ></v-checkbox>
            <v-btn color="primary" id="g-recaptcha" @click="save" :loading="loading" :disabled="loading">
                {{ 'Submit' | translation }}
            </v-btn>
        </v-form>

        <v-dialog v-model="displayErrorModal" width="550">
            <v-card>
                <v-card-text>
                    <span>
                        {{ "Das Formular konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder wenden Sie sich an unseren Support." | translation }}
                    </span>
                </v-card-text>

                <v-card-actions>
                    <v-btn @click="displayErrorModal = false">{{'Close' | translation}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import gql from 'graphql-tag';

import FileInput from '@/components/controlls/FileInput';

export default {
    name: 'ComplaintForm',
    components: { FileInput },
    data: () => ({
        firstName: '',
        lastName: '',
        orderId: '',
        brand: '',
        productName: '',
        serialNumber: '',
        phone: '',
        email: '',
        message: '',
        invoice: null,
        images: {
            photo1: null,
            photo2: null,
            photo3: null,
            photo4: null,
            packing: null,
        },
        CAPTCHA_KEY: '',

        brands: [
          "Weber",
          "Napoleon",
          "Monolith",
          "Kamado Joe",
          "Big Green Egg",
          "Outdoorchef",
          "Masterbuilt",
          "Simogas",
          "PitBoss",
          "Borniak",
          "OONI",
          "Otto Wilde",
          "Cactus Jack",
          "Hot Wok",
          "Moesta",
          "MeatStick",
          "Grillshop",
          "Andere",
        ],

        formSend: false,
        loading: false,
        displayErrorModal: false,
    }),
    mounted() {
        this.loadCaptcha(100, 10000, 'https://www.google.com/recaptcha/api.js');
        this.CAPTCHA_KEY = Vue.$config.CAPTCHA_PUBLIC_KEY;

        try {
            window.grecaptcha.ready(function() {
                window.grecaptcha.render('g-recaptcha', {
                    sitekey: Vue.$config.CAPTCHA_PUBLIC_KEY,
                });
            });
        } catch (e) {}
    },
    methods: {
        formValid() {
            return this.$refs.form.validate();
        },
        save() {
            window.grecaptcha
                .execute()
                .then(() => {
                    if (this.formValid()) {
                        this.loading = true;
                        this.sendForm({
                            firstName: this.firstName,
                            lastName: this.lastName,
                            orderId: this.orderId,
                            brand: this.brand,
                            productName: this.productName,
                            serialNumber: this.serialNumber,
                            phone: this.phone,
                            email: this.email,
                            message: this.message,
                        })
                            .then(() => {
                                this.loading = false;
                                this.$router.push('reklamation-abschluss');
                            })
                            .catch(e => {
                                this.loading = false;
                                this.displayErrorModal = true;
                                console.log(e);
                            });
                    }
                })
                .catch(e => console.log(e, 'ROBOT!'));
        },
        sendForm(complaint) {
            let that = this;
            return Vue.$graphql.mutate({
                mutation: gql`
                    mutation createComplaint($complaint: ComplaintInput!, $invoice: Upload, $images: [Upload!]!) {
                        createComplaint(complaint: $complaint, invoice: $invoice, images: $images)
                    }
                `,
                variables: {
                    complaint: complaint,
                    invoice: that.invoice,
                    images: Object.keys(that.images).reduce(function(r, e) {
                        if (that.images[e]) {
                            r.push(that.images[e]);
                        }
                        return r;
                    }, []),
                },
            });
        },
        loadCaptcha(callInterval, delay, url) {
            let that = this;
            let r,
                timeSpend,
                i = setInterval(function() {
                    timeSpend += callInterval;
                    r = typeof require === 'function';
                    if (timeSpend >= delay || r) clearInterval(i);
                    if (r) {
                        that.loadCaptchaScript(url)
                            .then(function() {
                                try {
                                    window.grecaptcha.ready(function() {
                                        window.grecaptcha.render('g-recaptcha', {
                                            sitekey: Vue.$config.CAPTCHA_PUBLIC_KEY,
                                        });
                                    });
                                } catch (e) {}
                            })
                            .catch(function(err) {
                                console.error('Something went wrong!', err);
                            });
                    }
                }, callInterval);
        },
        loadCaptchaScript(url) {
            return new Promise(function(resolve, reject) {
                let script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.id = 'captcha-script';
                script.src = url;
                script.onload = resolve;
                script.onerror = reject;
                if (!document.getElementById(script.id)) {
                    document.head.appendChild(script);
                }
            })
                .then(() => {
                    return true;
                })
                .catch(error => console.log(error));
        },
    },
    computed: {
        rules: function() {
            return {
                required: [v => !!v || this.$language.translate('Field is required.')],
                phone: [v => !!v || 'Nur Ziffern sind erlaubt.', v => !isNaN(v) || 'Nur Ziffern sind erlaubt.'],
                email: [
                    v => !!v || this.$language.translate('Field is required.'),
                    v => /.+@.+/.test(v) || this.$language.translate('E-mail must be valid.'),
                ],
                extension: [
                    v => !v || v.toLowerCase().match(/(\.jpg|\.jpeg|\.gif|\.png|\.pdf|\.mp4)$/) ||
                        this.$language.translate(
                            'The file must have one of the following extensions: .jpg, .jpeg, .gif, .png, .pdf, .mp4',
                        ),
                ],
            };
        },
    },
};
</script>

<style scoped></style>
